/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConduitSettingsComponent } from './conduit-settings.component';
import { SysqueOptionsLineModule } from '../../../../../../../../../shared/ui/src/lib/components/sysque-options-line';
import { ConduitSettingsSpoolTagModule } from './tag-options/spool-tag';
import { ConduitSettingsSizeTagModule } from './tag-options/size-tag';
import { ConduitSettingsItemNumberTagModule } from './tag-options/item-number-tag';
import { ConduitSettingsElevationTagModule } from './tag-options/elevation-tag';

@NgModule({
  declarations: [ConduitSettingsComponent],
  imports: [
    CommonModule,
    SysqueOptionsLineModule,
    ConduitSettingsSpoolTagModule,
    ConduitSettingsSizeTagModule,
    ConduitSettingsItemNumberTagModule,
    ConduitSettingsElevationTagModule
  ],
  exports: [ConduitSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConduitSettingsModule {}
